import Badges from ".";

export const badgeRoutes = () => [
  {
    path: "/admin/badge",
    title: "Badge Management",
    layout: "admin",
    routeType: "admin",
    component: Badges,
  },
]